import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'AccountUsersPanel',
  props: {
    accountId: null,
    isIxAdminSession: { type: Boolean },
    isAccountAdmin: { type: Boolean },
    listUsersFilter: null,
    disableReviewerRole: { type: Boolean },
    userTableColumns: null
  },
  setup(__props: any) {

const props = __props as {
  accountId: string
  isIxAdminSession: boolean
  isAccountAdmin: boolean
  listUsersFilter: Record<string, unknown>
  disableReviewerRole: boolean
  userTableColumns: readonly string[]
};



return { __sfc: true,props }
}

})